import moment from 'moment'
import { useSelector } from 'react-redux'
import { getActivePatientPlan } from '../utils/helpers/common'

const useGetPlanDetails = () => {
  const { patientDetails } = useSelector((state) => state.auth)
  const patientPlan = getActivePatientPlan(patientDetails?.data?.patient_plans)

  const expiry_date = patientPlan?.plan_end_date // '2025-04-13'
  const start_date = patientPlan?.plan_start_date // '2025-04-14'

  const expiryDate = expiry_date ? moment(expiry_date, 'YYYY-MM-DD') : moment()
  const startDate = start_date ? moment(start_date, 'YYYY-MM-DD') : moment()
  const currentDate = moment()
  const isPlanExpired = expiryDate.isBefore(currentDate)

  // Calculate progress based on dates
  const totalDays = patientPlan
    ? Math.ceil(expiryDate.diff(startDate, 'days')) + 1
    : 0
  const elapsedDays = patientPlan
    ? Math.ceil(currentDate.diff(startDate, 'days')) + 1
    : 0
  const currentProgress = Math.min(elapsedDays, totalDays)
  const remainingDays = Math.max(totalDays - elapsedDays, 0)

  return {
    patientDetails,
    totalDays,
    elapsedDays,
    expiryDate,
    startDate,
    currentDate,
    isPlanExpired: patientDetails?.data?.is_plan_expired == 1 ? true : false,
    currentProgress,
    remainingDays,
  }
}

export default useGetPlanDetails
